import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import { keycloakAuthModule } from './modules/auth';
import { navModule } from './modules/nav';
import { toolkitModule } from './modules/toolkit';
import { themeModule } from '@internal/plugin-1tdb-theme';

export default createApp({
  features: [
    catalogPlugin,
    kubernetesPlugin,
    navModule,
    toolkitModule,
    keycloakAuthModule,
    themeModule,
  ],
});
